import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { featureKey } from './reducers/feature-key';
import { genesysCloudCommonConversationReducer } from './reducers/common-conversation.reducers';
import { GenesysCloudConversationWorkItemEffects } from './effects/conversation-work-item.effects';
import { ConversationNotificationEffects } from './effects/conversation-notification.effects';
import { GenesysCloudConversationToastMessageEffects } from './effects/conversation-toast-message.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, genesysCloudCommonConversationReducer),
    EffectsModule.forFeature([
      GenesysCloudConversationWorkItemEffects,
      ConversationNotificationEffects,
      GenesysCloudConversationToastMessageEffects
    ])
  ]
})
export class GenesysCloudCommonConversationsModule {
}
